import ProgressBar from '../ProgressBar';

const ProgressBarLoading: React.FC = () => {
  return <ProgressBar />;
};

export default ProgressBarLoading;
